import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {OperationsModelService} from '../../../Models/Warehouse/Operations/operations-model.service';
import {forkJoin, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OperationsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: OperationsModelService,
  ) {
    super(injector);
  }

  /**
   * Obtener operaciones
   *
   */
  getOperations(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      const inventoriesApi: Observable<ApiResponse> = this.httpCall('getInventarios', {}, 'post', true);
      const reloadsApi: Observable<ApiResponse> = this.httpCall('getRecargas', {});
      const revisionsApi: Observable<ApiResponse> = this.httpCall('getRevisiones', {});

      return forkJoin([inventoriesApi, reloadsApi, revisionsApi]).subscribe({
        next: ([responseInventories, responseReloads, responseRevisions]) => {

          const combinedResponse = {
            duracion: responseInventories.duracion,
            mensaje: `${responseInventories.mensaje}, ${responseReloads.mensaje}, ${responseRevisions.mensaje}`,
            status: responseInventories.status === responseReloads.status ? responseInventories.status : 0,
            data: {
              inventarios: responseInventories.data,
              revisiones: responseRevisions.data,
              recargas: responseReloads.data,
            }
          };

          if (save) {
            this.model.save(combinedResponse.data);
          }

          resolve(combinedResponse);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener el detalle de una operación de inventario
   *
   */
  getInventoryOperation(params: { id: string }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getInventarioDetail', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener el detalle de una operación de recarga
   *
   */
  getReloadOperation(params: {
    id_recarga: number,
    filtro_usuario: number,
    filtro_ubicacion: number,
  }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getLineasRecarga', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
